import {alias, createModelSchema} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";

import {HeroKind} from "../hero/HeroKind";
import {GuardConfig} from "../guard/GuardConfig";
import {TriggerUtils} from "../trigger/core/TriggerUtils";


export class TalkModel extends BaseObject {

    constructor() {
        super();

        this._id = null;
        this._key = null;
        this._name = null;

        this._guard = new GuardConfig();
        this._owner = HeroKind.NONE;
        this._delayOnShow = 0;
        this._resetOnClose = false;
        this._triggersAvailable = [];
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get guard() {
        return this._guard;
    }

    set guard(value) {
        this._guard = value;
    }

    get owner() {
        return this._owner;
    }

    set owner(value) {
        this._owner = value;
    }

    get delayOnShow() {
        return this._delayOnShow;
    }

    set delayOnShow(value) {
        this._delayOnShow = value;
    }

    get resetOnClose() {
        return this._resetOnClose;
    }

    set resetOnClose(value) {
        this._resetOnClose = value;
    }

    get triggersAvailable() {
        return this._triggersAvailable;
    }

    set triggersAvailable(value) {
        this._triggersAvailable = value;
    }

    valid() {

        if (!HeroKind.is(this.owner)) {
            return false;
        }

        if (Number.isNaN(this.delayOnShow) || this.delayOnShow < 0) {
            return false;
        }

        if (this.guard && !this.guard.valid()) {
            return false;
        }

        if (this.triggersAvailable.some(v => !v || !v.valid())) {
            return false;
        }

        return true;
    }

    copy() {
        return super.copy();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TalkModel());
        } else if (target instanceof TalkModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(TalkModel, {
    _id: alias("id", Schema.primitive()),
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),

    _guard: alias("guard", GuardConfig.schema()),
    _owner: alias("owner", HeroKind.schema()),
    _delayOnShow: alias("delay_show", Schema.primitive()),
    _resetOnClose: alias("reset_close", Schema.primitive()),

    _triggersAvailable: alias("triggers_available", TriggerUtils.schema()),
});